import { Goal } from "@/app/entities/Team";
import { httpClient } from "../http/httpClient";

export interface TeamParams {
  name: string;
  about: string;
  goal?: {
    value: number;
    commission: number;
  }[];
  goals?: Record<string, Goal[]>;
}

export interface TeamResponse {
  name: string;
  about: string;
  manager_id: string;
  leader_id: string;
  goal: {
    value: number;
  };
  goals: {
    [key: string]: Goal[];
  };
  members: {
    _id: string;
    profileImageUrl: string;
  }[];
}

export const createTeam = async (teamData: TeamParams) => {
  const { data } = await httpClient
    .post<TeamResponse>("/team", teamData)
    .catch((error) => {
      throw error.response.data;
    });

  return data;
};
